import type { StatsPeriod } from '@/entities/admin-stats.entity';

export function periodToRange(period: StatsPeriod): { from: string | null; to: string } {
	const now = new Date();
	const to = now.toISOString();

	switch (period) {
		case 'day':
			return { from: new Date(now.getTime() - 24 * 60 * 60 * 1000).toISOString(), to };
		case 'week':
			return { from: new Date(now.getTime() - 7 * 24 * 60 * 60 * 1000).toISOString(), to };
		case 'month':
			return { from: new Date(now.getTime() - 30 * 24 * 60 * 60 * 1000).toISOString(), to };
		case 'all':
			return { from: null, to };
	}
}
